import { RenderActivateContent } from './renderActivateContent'

export default function ActivateTwoColumnFooter({ title, variant }) {
  return RenderActivateContent({ title, variant })
}
